import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'

export type WarehouseNoteStatus =
    'pending' | 'approved' | 'rejected' | 'cancelled'

const STATUS_CLASS: Record<WarehouseNoteStatus, string> = {
    pending: 'bg-status-pending text-status-pending-foreground',
    approved: 'bg-status-approved text-status-approved-foreground',
    rejected: 'bg-status-rejected text-status-rejected-foreground',
    cancelled: 'bg-status-cancelled text-status-cancelled-foreground',
}

export function warehouseNoteStatusClass(status: WarehouseNoteStatus): string {
    return STATUS_CLASS[status]
}

/** Nhãn trạng thái phiếu kho dùng chung — badge trên màn hình và bản in đều gọi. */
export function warehouseNoteStatusLabel(status: WarehouseNoteStatus): string {
    switch (status) {
        case 'pending':
            return m.sl_note_status_pending()
        case 'approved':
            return m.sl_note_status_approved()
        case 'rejected':
            return m.sl_note_status_rejected()
        case 'cancelled':
            return m.sl_note_status_cancelled()
    }
}

interface Props {
    status: WarehouseNoteStatus
    label?: string
    className?: string
}

export function WarehouseNoteStatusBadge({ status, label, className }: Props) {
    return (
        <Badge
            className={`${warehouseNoteStatusClass(status)} ${className ?? ''}`}
        >
            {label ?? warehouseNoteStatusLabel(status)}
        </Badge>
    )
}
